export default "/images/vendor/flag-icons/flags/4x3/es-ga.svg?c1f547a8db225475769bd49b4fb570a3";